/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Create_ResumeInputs */

const en_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a resume`)
};

const de_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf erstellen`)
};

const fr_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un CV`)
};

const es_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear un currículum`)
};

const it_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un curriculum vitae`)
};

const nl_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een cv`)
};

const pl_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stwórz CV`)
};

const fi_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo ansiotodistus`)
};

const da_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret et CV`)
};

const sv_dashboard_step_create_resume = /** @type {(inputs: Dashboard_Step_Create_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ett CV`)
};

/**
* | output |
* | --- |
* | "Create a resume" |
*
* @param {Dashboard_Step_Create_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_create_resume = /** @type {((inputs?: Dashboard_Step_Create_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Create_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_create_resume(inputs)
	if (locale === "fr") return fr_dashboard_step_create_resume(inputs)
	if (locale === "es") return es_dashboard_step_create_resume(inputs)
	if (locale === "it") return it_dashboard_step_create_resume(inputs)
	if (locale === "nl") return nl_dashboard_step_create_resume(inputs)
	if (locale === "pl") return pl_dashboard_step_create_resume(inputs)
	if (locale === "fi") return fi_dashboard_step_create_resume(inputs)
	if (locale === "da") return da_dashboard_step_create_resume(inputs)
	if (locale === "sv") return sv_dashboard_step_create_resume(inputs)
	return en_dashboard_step_create_resume(inputs)
});